import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import {
	AppError,
	AuthenticationStatus,
	AuthSelector,
	JurisdictionSelector,
	MessageService,
	SessionSelector,
} from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { merge, of } from "rxjs";
import { catchError, filter, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { PRODUCT_LINK_ACTION_TYPE, ProductLinkAction } from "./product-link.action";
import { PRODUCT_LINK_CONTEXT } from "./product-link.const";
import { ProductLinkService } from "./product-link.service";

@Injectable()
export class ProductLinkEffect {
	getWidgets$ = createEffect(() =>
		this.actions$.pipe(
			ofType(PRODUCT_LINK_ACTION_TYPE.get),
			mergeMap(() =>
				this.store.select(AuthSelector.getAuthenticationStatus).pipe(
					filter((status) => status !== AuthenticationStatus.Pending),
					withLatestFrom(
						this.store.select(this.sessionSelector.isAuthenticated()),
						this.store.pipe(select(JurisdictionSelector.get), ignoreNil())
					),
					switchMap(([, isAuthenticated, jurisdiction]) =>
						this.service
							.get({
								isLoggedIn: isAuthenticated,
								jurisdiction,
							})
							.pipe(
								map((response) => this.action.getSuccess(response)),
								catchError((error: AppError) => of(this.action.getFail(error)))
							)
					)
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[PRODUCT_LINK_ACTION_TYPE.getFail]: PRODUCT_LINK_CONTEXT.get,
			}),
			this.messageService.mapClearByContext$({
				[PRODUCT_LINK_ACTION_TYPE.get]: PRODUCT_LINK_CONTEXT.get,
			})
		)
	);

	constructor(
		private action: ProductLinkAction,
		private actions$: Actions,
		private service: ProductLinkService,
		private messageService: MessageService,
		private store: Store<CommonState>,
		private sessionSelector: SessionSelector
	) {}
}
